export const types = {
  OFFER: "offer",
  CANDIDATE: "candidate",
  ENDED: "ended",
  REJECT: "reject",
  CALL: "call",
}
